function collectionItemsInit() {
  const collectionItems = document.querySelectorAll('[data-collection-item]');
  if (!collectionItems) { return; }
  collectionItems.forEach(item => {
    collectionItemInit(item);
  });
}

export function collectionItemInit(item) {
  const helpOpen = item.querySelector('[data-collection-item-help-toggle]');
  const helpClose = item.querySelector('[data-collection-item-help-close]');

  if (!helpOpen || !helpClose) { return; }

  helpOpen.addEventListener('click', () => {
    item.classList.add('flipped');
    item.classList.add('flipping');
    setTimeout(() => item.classList.remove('flipping'), 500);
  });

  helpClose.addEventListener('click', () => {
    item.classList.remove('flipped');
    item.classList.add('flipping');
    setTimeout(() => item.classList.remove('flipping'), 500);
  });
}

document.addEventListener('DOMContentLoaded', () => {
  collectionItemsInit();
});
